export const lineHeights = {
  "3.5": "0.875rem",
  "14": "3.5rem",
}
